<template>
  <v-row no-gutters class="d-flex flex-row justify-center fill-height">
    <v-col cols="12" md="6" sm="12">
      <v-card
        class="d-flex flex-column"
        width="100%"
        height="100%"
        tile
        flat
        color="newBackground"
      >
        <v-card-title :class="$vuetify.breakpoint.mdAndUp ? 'mt-12 pb-0' : ''">
          <v-row
            no-gutters
            class="d-flex flex-column align-center justify-center"
          >
            <v-col :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'">
              <v-row>
                <v-col class="col-auto">
                  <a href="https://www.pandavideo.com.br/">
                    <img
                      v-if="$vuetify.theme.dark"
                      height="40"
                      class="mousePointer"
                      src="../../assets/logoWhite.svg"
                    />
                    <img
                      v-else
                      height="40"
                      class="mousePointer"
                      src="../../assets/logoBlack.svg"
                    />
                  </a>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'"
              class="mt-10"
              v-if="couponInfo"
            >
              <v-card width="100%" class="couponAdded" flat>
                <v-row class="fill-height" no-gutters>
                  <v-icon class="mr-4" color="#4CAF50">
                    mdi-tag-multiple
                  </v-icon>
                  <v-row
                    class="fill-height pr-2 flex-column justify-center"
                    no-gutters
                  >
                    <div class="coupounText d-inline-flex">
                      {{ $t('message.pages.login.couponAdded') }}
                    </div>
                    <div class="couponName d-inline-flex">
                      {{ couponInfo.name }}
                    </div>
                  </v-row>
                </v-row>
              </v-card>
            </v-col>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'"
              class="mt-10"
              v-if="errCoupon"
            >
              <v-card width="100%" height="40px" color="error" flat outlined>
                <v-row class="fill-height" no-gutters align="center">
                  <v-icon class="mx-3"> mdi-alert </v-icon>
                  <span class="invalidCoupon white--text">
                    {{ $t('message.pages.login.invalidCoupon') }}
                    <b>"{{ errCoupon }}"</b>
                  </span>
                </v-row>
              </v-card>
            </v-col>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'"
              :class="$vuetify.breakpoint.mdAndUp ? 'mt-10' : 'mt-4'"
            >
              <span class="wrapText chosePlan pb-0 pb-md-2">
                {{ $t('message.pages.login.chosenPlan') }}
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <template v-if="$vuetify.breakpoint.mdAndUp">
          <v-card
            width="100%"
            height="100%"
            flat
            tile
            class="d-flex flex-row justify-center"
            color="newBackground"
          >
            <v-row no-gutters class="justify-center">
              <v-col v-if="productsLoading" cols="10" class="ml-6 pt-8">
                <loading-logo :value="200" />
              </v-col>
              <v-col
                v-else
                cols="10"
                style="padding: 0 0.825rem; gap: 1rem"
                class="d-flex ga-4 flex-column"
              >
                <v-card
                  v-for="(plan, i) in plans"
                  :key="i"
                  outlined
                  :ripple="false"
                  width="100%"
                  class="d-flex align-start item-plan rounded-lg"
                  :class="{
                    selected:
                      createAccountParamsUrl.planName ===
                      plan.name.toLowerCase(),
                  }"
                  @click="onSelectPlan(plan)"
                  flat
                >
                  <v-radio-group
                    class="my-4 ml-4 mr-2"
                    v-model="createAccountParamsUrl.planName"
                    v-if="
                      createAccountParamsUrl.planName ===
                      plan.name.toLowerCase()
                    "
                  >
                    <v-radio :value="createAccountParamsUrl.planName"></v-radio>
                  </v-radio-group>
                  <v-radio v-else class="my-5 ml-4 mr-2"></v-radio>
                  <v-row no-gutters>
                    <v-col cols="6">
                      <v-row no-gutters>
                        <v-col cols="12" class="mt-4">
                          <v-row no-gutters>
                            <span
                              class="text--center planTitle font-weight-medium"
                            >
                              {{ plan.name }}
                              <v-tag
                                type="success"
                                v-if="plan.name === 'Silver'"
                                >{{
                                  $t('message.pages.login.mostPopular')
                                }}</v-tag
                              >
                            </span>
                          </v-row>
                        </v-col>
                        <v-col cols="12" class="mt-2">
                          <span class="text--start perkPlan">
                            <span class="text--secondary">
                              <span class="font-weight-medium text--primary">{{
                                calcBytes(plan.metadata.storage)
                              }}</span>
                              {{ $t('message.pages.Cart.ofStorage') }}
                            </span>
                          </span>
                        </v-col>
                        <v-col cols="12" class="mt-2 mb-4">
                          <span class="text--start perkPlan">
                            <span class="text--secondary">
                              <span class="font-weight-medium text--primary">{{
                                calcBytes(plan.metadata.transfer)
                              }}</span>
                              {{ $t('message.pages.Cart.ofTrafficPerMonth') }}
                            </span>
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6" class="d-flex align-center">
                      <v-row
                        no-gutters
                        class="align-end justify-end pr-2 priceText flex-column"
                      >
                        <div class="d-flex">
                          <span
                            :class="couponInfo ? 'originalValue' : ''"
                            class="text--center pr-2"
                            >{{ moneyCurrency }}
                            <span>{{
                              (plan.prices[0].unit_amount / 100)
                                .toFixed(2)
                                .split('.')[0]
                            }}</span
                            >,{{
                              (plan.prices[0].unit_amount / 100)
                                .toFixed(2)
                                .split('.')[1]
                            }}<span v-if="!couponInfo"
                              >/{{ $t('message.month') }}</span
                            ></span
                          >

                          <div v-if="couponInfo">
                            <span class="text--center text-h6"
                              >{{ moneyCurrency }}
                              <span class="">{{
                                (
                                  getAmountWithCoupon(
                                    plan.prices[0].unit_amount
                                  ) / 100
                                )
                                  .toFixed(2)
                                  .split('.')[0]
                              }}</span
                              >,{{
                                (
                                  getAmountWithCoupon(
                                    plan.prices[0].unit_amount
                                  ) / 100
                                )
                                  .toFixed(2)
                                  .split('.')[1]
                              }}/{{ $t('message.month') }}
                              {{
                                couponInfo.duration !== 'forever' ? '*' : ''
                              }}</span
                            >
                          </div>
                        </div>
                        <span class="perkPlan pr-2">{{
                          $t('message.pages.login.freeTrialDays')
                        }}</span>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
                <v-row class="ml-0 mt-3 d-inline-block pr-2" v-if="couponInfo">
                  <span
                    v-if="couponInfo.duration === 'repeating'"
                    class="text--center text-subtitle-2 text--secondary"
                    >{{
                      $t('message.pages.login.coupon_repeating', {
                        month: couponInfo.duration_in_months,
                      })
                    }}</span
                  >
                  <span
                    v-if="couponInfo.duration === 'once'"
                    class="text--center text-subtitle-2 text--secondary"
                    >{{ $t('message.pages.login.coupon_once') }}</span
                  >
                </v-row>
                <v-row class="my-0">
                  <v-col class="mb-12 trialAdvice py-1">
                    {{ $t('message.pages.signup.trialLimit') }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </template>
        <v-row v-else no-gutters class="justify-center align-center">
          <v-col cols="12">
            <v-row no-gutters align="center" justify="center" class="mx-4">
              <v-card
                v-if="selectedPlan.name"
                outlined
                width="100%"
                class="d-inline-block item-plan selected"
              >
                <v-row no-gutters>
                  <v-col cols="7" class="pl-4">
                    <v-row no-gutters>
                      <v-col cols="12" class="mt-4">
                        <v-row no-gutters>
                          <span
                            class="text--center font-weight-medium planTitle"
                          >
                            {{ selectedPlan.name }}
                          </span>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <span class="text--start perkPlan">
                          <span class="text--secondary">
                            <span class="font-weight-medium text--primary">{{
                              calcBytes(selectedPlan.metadata.storage)
                            }}</span>
                            {{ $t('message.pages.Cart.ofStorage') }}
                          </span>
                        </span>
                      </v-col>
                      <v-col cols="12" class="mb-4">
                        <span class="text--start perkPlan">
                          <span class="text--secondary">
                            <span class="font-weight-medium text--primary">{{
                              calcBytes(selectedPlan.metadata.transfer)
                            }}</span>
                            {{ $t('message.pages.Cart.ofTrafficPerMonth') }}
                          </span>
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="5" class="mt-4">
                    <v-row
                      no-gutters
                      class="align-end justify-end flex-column pr-2 priceText"
                      :class="!$vuetify.theme.dark && 'priceTextColor'"
                    >
                      <span
                        :style="{
                          textDecoration: couponInfo ? 'line-through' : 'none',
                        }"
                        :class="{
                          caption: couponInfo,
                        }"
                        class="text--center text--secondary pr-2"
                        >{{ moneyCurrency }}
                        <span class="text--primary">{{
                          (selectedPlan.prices[0].unit_amount / 100)
                            .toFixed(2)
                            .split('.')[0]
                        }}</span
                        >,{{
                          (selectedPlan.prices[0].unit_amount / 100)
                            .toFixed(2)
                            .split('.')[1]
                        }}/{{ $t('message.month') }}</span
                      >
                      <v-row
                        class="justify-center mt-0 mb-0 pr-2"
                        v-if="couponInfo"
                      >
                        <span
                          class="text--center text-subtitle-2 text--secondary"
                          >{{ moneyCurrency }}
                          <span class="text-h6 text--primary">{{
                            (
                              getAmountWithCoupon(
                                selectedPlan.prices[0].unit_amount
                              ) / 100
                            )
                              .toFixed(2)
                              .split('.')[0]
                          }}</span
                          >,{{
                            (
                              getAmountWithCoupon(
                                selectedPlan.prices[0].unit_amount
                              ) / 100
                            )
                              .toFixed(2)
                              .split('.')[1]
                          }}/{{ $t('message.month') }}
                          {{
                            couponInfo.duration !== 'forever' ? '*' : ''
                          }}</span
                        >
                      </v-row>
                      <span class="caption pr-2">{{
                        $t('message.pages.login.freeTrialDays')
                      }}</span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-row>
          </v-col>
          <v-col cols="12" class="my-3">
            <v-row no-gutters align="center" justify="center">
              <span
                @click="handleOpenMobilePlans"
                class="primary--text requirementsText"
              >
                {{ $t('message.pages.login.checkAllPlans') }}
              </span>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
      sm="12"
      :class="$vuetify.breakpoint.smAndUp && 'fill-height'"
    >
      <v-card width="100%" height="100%" flat tile class="d-flex flex-column">
        <v-card-text
          class="pb-0 mb-0"
          :class="{
            signUpFormCard: $vuetify.breakpoint.mdAndUp,
          }"
          :style="
            !$vuetify.theme.dark ? 'background: white' : 'background: dark'
          "
        >
          <v-row no-gutters class="align-center">
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? '8' : '12'"
              :class="$vuetify.breakpoint.mdAndUp ? 'mt-10' : 'mt-3'"
            >
              <span
                class="signUpTitle"
                :class="!$vuetify.theme.dark && 'signUpTitleColor'"
                >{{ $t('message.pages.login.fillYourData') }}</span
              >
            </v-col>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? '8' : '12'"
              class="mb-10"
            >
              <span
                class="signUpSubtitle"
                :class="!$vuetify.theme.dark && 'signUpSubtitleColor'"
              >
                {{ $t('message.pages.login.alreadyGotAccount') }}
                <a type="secondary" @click="loginPage()">{{
                  $t('message.pages.login.access')
                }}</a>
              </span>
            </v-col>
            <v-col
              v-if="isDomainFromBrazil"
              :cols="$vuetify.breakpoint.mdAndUp ? '8' : '12'"
              class="mb-3"
            >
              <v-row no-gutters class="align-center">
                <v-col cols="12">
                  <span class="accountTypeText">{{
                    $t('message.pages.login.accountType')
                  }}</span>
                </v-col>
                <v-col>
                  <v-btn-toggle
                    class="d-flex"
                    v-model="isLegalPerson"
                    mandatory
                  >
                    <v-btn
                      small
                      class="text-none rounded-lg mr-2 px-3"
                      :class="isLegalPerson ? 'selectedButton' : ''"
                      outlined
                      hide-details
                      :value="true"
                      >{{ $t('message.pages.login.physicalPerson') }}</v-btn
                    >
                    <v-btn
                      small
                      class="text-none rounded-lg px-3"
                      :class="!isLegalPerson ? 'selectedButton' : ''"
                      outlined
                      :value="false"
                      hide-details
                      >{{ $t('message.pages.login.legalPerson') }}</v-btn
                    >
                  </v-btn-toggle>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'"
              class="mt-8"
            >
              <template v-if="isLegalPerson">
                <v-input
                  v-model="newUser.name"
                  type="text"
                  :messages="invalidName"
                  :error="errors.userNameInvalid"
                  :placeholder="$t('message.insertName')"
                  :label="$t('message.pages.login.name')"
                >
                </v-input>
              </template>
              <template v-else>
                <v-input
                  v-model="newUser.company"
                  :messages="invalidName"
                  :error="errors.userNameInvalid"
                  :label="$t('message.pages.login.company')"
                  :placeholder="$t('message.pages.login.insertCompany')"
                >
                </v-input>
              </template>
              <v-row class="mt-1">
                <v-col :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'">
                  <v-form v-model="valid">
                    <v-input
                      v-model="login.user.email"
                      :placeholder="$t('message.insertEmail')"
                      outlined
                      :messages="handleEmailError"
                      :error="
                        createAccountError.invalidEmail ||
                        createAccountError.userAlreadyExists
                      "
                      @keyup.enter="regexEmail()"
                      label="E-mail"
                      @input="
                        ;(rewritingForm = true),
                          (createAccountError.userAlreadyExists = false)
                      "
                      :rules="[rules.emailFormat]"
                    >
                    </v-input>
                  </v-form>
                </v-col>

                <v-col :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'">
                  <v-form v-model="valid">
                    <v-input
                      v-model="login.user.emailConfirm"
                      :placeholder="$t('message.pages.login.emailConfirm')"
                      :rules="[
                        rules.emailEqual(
                          login.user.emailConfirm,
                          login.user.email
                        ),
                      ]"
                      :error="createAccountError.emailConfirm && !rewritingForm"
                      :label="$t('message.pages.login.emailConfirm')"
                      @input="
                        ;(rewritingForm = true),
                          (createAccountError.emailConfirm = false)
                      "
                      @keyup.enter="regexEmail()"
                      @paste.prevent
                    >
                    </v-input>
                  </v-form>

                  <template
                    v-if="
                      createAccountError.internalServerError && !rewritingForm
                    "
                  >
                    <span class="red--text footerText align-text mt-2 d-block">
                      {{ $t('message.errors.internalServerError') }} -
                      {{ $t('message.errors.pleaseTryAgain') }}
                    </span>
                  </template>
                </v-col>
              </v-row>
              <v-col
                class="pa-0 pb-6"
                :cols="$vuetify.breakpoint.mdAndUp ? '5' : '12'"
                style="margin-top: -16px; position: relative; z-index: 99"
              >
                <span
                  class="labelPhone"
                  :class="!isValidPhoneNumber ? 'errorMsg' : ''"
                  >{{ $t('message.pages.checkout.phone') }}</span
                >
                <template>
                  <VuePhoneNumberInput
                    no-example
                    default-country-code="BR"
                    :dark="$vuetify.theme.dark"
                    clearable
                    :color="$vuetify.theme.dark ? '#171924' : '#fff'"
                    :translations="translationsPhoneInput"
                    :error="!isValidPhoneNumber"
                    :valid-color="$vuetify.theme.dark ? '#171924' : '#fff'"
                    :error-color="$vuetify.theme.dark ? '#171924' : '#fff'"
                    :preferred-countries="['BR', 'US']"
                    @phone-number-focused="handleFocus"
                    @phone-country-focused="handleFocus"
                    @update="checkIfIsValidPhoneNumber"
                    v-model="clientPhone"
                  />
                </template>
                <span v-if="!isValidPhoneNumber" class="d-flex errorMsg">{{
                  $t('message.pages.login.insertValidPhoneNumber')
                }}</span>
              </v-col>
              <v-col
                class="pa-0 mt-4"
                :cols="$vuetify.breakpoint.mdAndUp ? '5' : '12'"
                v-if="isDomainFromBrazil"
              >
                <template v-if="isLegalPerson">
                  <v-input
                    v-model="owner.document"
                    v-mask="['###.###.###-##']"
                    placeholder="000.000.000-00"
                    :messages="invalidDataInfo"
                    label="CPF"
                    :error="errors.invalidCpf"
                  >
                  </v-input>
                </template>
                <template v-else>
                  <v-input
                    v-model="owner.document"
                    v-mask="['##.###.###/####-##']"
                    :placeholder="$t('message.pages.login.insertCnpj')"
                    :messages="invalidDataInfo"
                    label="CNPJ"
                    :error="errors.invalidCnpj"
                  >
                  </v-input>
                </template>
              </v-col>
            </v-col>

            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'"
              class="mt-2"
            >
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-row no-gutters>
                    <v-checkbox
                      v-model="checkboxAcceptTerms"
                      class="d-inline-block float-left mt-0 acceptTerms"
                      hide-details
                      :label="$t('message.pages.login.readAndAgreeTerms')"
                    ></v-checkbox>
                    <a
                      target="_blank"
                      :href="`https://pandavideo.com${
                        isDomainFromBrazil ? '.br' : ''
                      }/terms/`"
                      type="secondary"
                      class="ml-1"
                      style="margin-top: 5px"
                      >{{ $t('message.pages.login.termsOfUse') }}</a
                    >
                  </v-row>
                </v-col>
              </v-row>

              <template v-if="!errors.checkboxAcceptTerms">
                <span class="red--text footerText align-text mt-2 d-block">
                  {{ $t('message.requiredField') }}
                </span>
              </template>

              <template v-else>
                <span class="mt-2 d-block" style="height: 16px"> </span>
              </template>
            </v-col>

            <v-col cols="10" class="mt-4">
              <base-btn
                large
                flat
                type="primary"
                class="rounded-lg"
                :loading="signInLoading"
                :disabled="signInLoading || !valid"
                @click="regexEmail()"
              >
                <span>{{ $t('message.createAccount') }}</span>
              </base-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <RedirectUrlSignup />
        <v-row
          no-gutters
          align="end"
          justify="center"
          class="pl-2"
          :class="$vuetify.breakpoint.mdAndUp ? 'mt-12' : 'mt-6'"
        >
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? '10' : '12'">
            <v-row no-gutters class="ml-2 mb-12 justify-space-between">
              <v-col
                :cols="$vuetify.breakpoint.mdAndUp ? '6' : '12'"
                class="flex-column flex-md-row justify-center align-center ga-4"
              >
                <span class="footerText d-block d-md-inline-flex text-center">
                  <a class="footerLinks mr-4" :href="helpLink" target="_blank">
                    {{ $t('message.help') }}
                  </a>
                </span>
                <span
                  class="footerText d-block d-md-inline-flex text-center mt-4 mt-md-0"
                >
                  <a
                    class="footerLinks"
                    href="https://pandavideo.com.br/privacy/"
                    target="_blank"
                  >
                    {{ $t('message.privacyPolicy') }}
                  </a>
                </span>
              </v-col>

              <v-col
                :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
                align-self="end"
                class="mt-4 mt-md-0 mr-md-8"
              >
                <v-row no-gutters class="justify-center justify-md-end">
                  <span class="footerText d-block d-md-inline-flex">
                    &copy; {{ getYear }} Panda Video
                  </span>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-dialog
      v-if="!$vuetify.breakpoint.mdAndUp"
      v-model="mobilePlansDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="dialogPlansMobile">
        <v-toolbar flat class="mt-4 dialogPlansMobile">
          <v-toolbar-title>{{
            $t('message.pages.login.chosePlan')
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="mobilePlansDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-col v-if="productsLoading" cols="12" class="ml-3 pt-4">
          <loading-logo :value="200" />
        </v-col>
        <v-card
          v-else
          v-for="(plan, i) in plans"
          :key="i"
          outlined
          class="d-inline-block item-plan mt-3 mx-4"
          :class="{
            selected:
              createAccountParamsUrl.planName === plan.name.toLowerCase(),
          }"
          @click="onSelectPlan(plan, true)"
          flat
        >
          <v-row no-gutters>
            <v-col cols="7" class="pl-4">
              <v-row no-gutters>
                <v-col cols="12" class="mt-4">
                  <v-row no-gutters>
                    <span class="text--center planTitle font-weight-medium">
                      {{ plan.name }}
                    </span>
                  </v-row>
                </v-col>
                <v-col cols="12" class="mt-2">
                  <span class="text--start caption">
                    <span class="text--secondary">
                      <span class="font-weight-medium text--primary perkPlan">{{
                        calcBytes(plan.metadata.storage)
                      }}</span>
                      {{ $t('message.pages.Cart.ofStorage') }}
                    </span>
                  </span>
                </v-col>
                <v-col cols="12" class="mb-4">
                  <span class="text--start caption">
                    <span class="text--secondary">
                      <span class="font-weight-medium text--primary perkPlan">
                        {{ calcBytes(plan.metadata.transfer) }}
                      </span>
                      {{ $t('message.pages.Cart.ofTrafficPerMonth') }}
                    </span>
                  </span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="5" class="pt-6">
              <v-row
                no-gutters
                class="align-end justify-end flex-column pr-0 pr-md-2 mr-4 priceText"
                :class="!$vuetify.theme.dark && 'priceTextColor'"
                style="font-size: 16px"
              >
                <span
                  :style="{
                    textDecoration: couponInfo ? 'line-through' : 'none',
                  }"
                  class="text--center pr-2"
                  >{{ moneyCurrency }}
                  <span>{{
                    (plan.prices[0].unit_amount / 100).toFixed(2).split('.')[0]
                  }}</span
                  >,{{
                    (plan.prices[0].unit_amount / 100).toFixed(2).split('.')[1]
                  }}/{{ $t('message.month') }}</span
                >
                <v-row class="justify-center mt-0 mb-0 pr-2" v-if="couponInfo">
                  <span class="text--center text-subtitle-2"
                    >{{ moneyCurrency }}
                    <span class="text-h6">{{
                      (getAmountWithCoupon(plan.prices[0].unit_amount) / 100)
                        .toFixed(2)
                        .split('.')[0]
                    }}</span
                    >,{{
                      (getAmountWithCoupon(plan.prices[0].unit_amount) / 100)
                        .toFixed(2)
                        .split('.')[1]
                    }}/{{ $t('message.month') }}
                    {{ couponInfo.duration !== 'forever' ? '*' : '' }}</span
                  >
                </v-row>
                <span class="caption pr-2">{{
                  $t('message.pages.login.freeTrialDays')
                }}</span>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
        <v-col class="mb-5 trialAdvice py-1 mt-16">
          {{ $t('message.pages.signup.trialLimit') }}
        </v-col>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import axios from 'axios'
import { mask } from 'vue-the-mask'
import prettyBytes from 'pretty-bytes'
import { API_URL, IS_CPF, IS_CNPJ } from '../../config/envs'
import {
  PANDA_HELP_STORAGE_LINK,
  PANDA_HELP_TRAFFIC_LINK,
} from '@/config/envs.js'
import linkHelper from '@/utils/linkHelper.mixin.js'
import LoadingLogo from '@/components/LoadingLogo.vue'
import VuePhoneNumberInput from 'vue-phone-number-input'
import RedirectUrlSignup from '@/components/RedirectBasedInLocale.vue'
import i18n from '@/translations/lang'

export default {
  name: 'SignUp',
  components: {
    LoadingLogo,
    VuePhoneNumberInput,
    RedirectUrlSignup,
  },
  directives: { mask },
  mixins: [linkHelper],
  data: () => ({
    createAccountParamsUrl: {
      planName: '',
    },
    selectedPlan: {},
    model: 0,
    rules: {
      emailFormat: (v) => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return pattern.test(v) || i18n.t('message.formatEmail')
      },
      emailEqual: (confirmEmail, email) => {
        return email === confirmEmail || i18n.t('message.errors.notEqualEmail')
      },
    },
    signInLoading: false,
    isLegalPerson: true,
    clientPhone: '',
    valid: false,
    isValidPhoneNumber: true,
    checkboxAcceptTerms: false,
    newUser: {
      name: '',
      cpf: '',
      cnpj: '',
      company: '',
      clientRole: '',
      clientReasoning: ['curso'],
      clientTeamSize: '',
    },
    clientReasoningOthersText: '',
    translationsPhoneInput: {
      countrySelectorLabel: 'Code pays',
      countrySelectorError: 'Choisir un pays',
      phoneNumberLabel: i18n.t('message.pages.login.insertPhoneNumber'),
      example: 'Exemple :',
    },
    userPossibleRoles: [
      'CEO',
      i18n.t('message.pages.signup.roleManager'),
      i18n.t('message.pages.signup.roleDeveloper'),
      'Designer',
    ],
    userPossibleReasons: [
      { text: i18n.t('message.pages.signup.reasonCourse'), value: 'curso' },
      { text: i18n.t('message.pages.signup.reasonVsl'), value: 'vsl' },
      { text: i18n.t('message.pages.signup.reasonOthers'), value: 'others' },
    ],
    userTeamSize: ['1 - 5', '6 - 20', '21 - 50', '51 - 100', '+100'],
    selectedFisicalPerson: false,
    choosePlan: false,
    plans: [],
    owner: {
      document: '',
    },
    errors: {
      invalidCpf: false,
      invalidCnpj: false,
      userNameInvalid: false,
      cnpjCpfEmptyField: false,
      checkboxAcceptTerms: true,
      reasonLength: false,
    },
    login: {
      user: {
        email: '',
        name: '',
        password: '',
        emailConfirm: '',
      },
      error: {
        invalidAccountError: false,
        userNotFound: false,
        emptyFields: false,
        unexpectedError: false,
        resetPasswordRequired: false,
      },
    },
    createAccountError: {
      internalServerError: false,
      userAlreadyExists: false,
      invalidEmail: false,
      emailConfirm: false,
      invalidPhoneNumber: false,
    },
    rewritingForm: false,
    rewritingFormCpfOrCnpj: false,
    couponInfo: false,
    productsLoading: false,
    mobilePlansDialog: false,
    errCoupon: '',
    phoneInternational: false,
    selected: [],
  }),
  computed: {
    locale() {
      return this.$i18next.resolvedLanguage
    },
    helpLink() {
      return this.getHelpLink()
    },
    getYear() {
      const date = new Date()
      return date.getFullYear()
    },
    isDomainFromBrazil() {
      return location.host.match(/.com$/) ? false : true
    },
    moneyCurrency() {
      return this.isDomainFromBrazil ? 'R$' : 'US$'
    },
    planName() {
      return this.createAccountParamsUrl.planName
    },
    handleEmailError() {
      if (this.createAccountError.userAlreadyExists) {
        return i18n.t('message.errors.userAlreadyExists')
      }
      return ''
    },
    invalidName() {
      if (this.errors.userNameInvalid) {
        return i18n.t('message.pages.profile.errors.invalidName')
      }
      return ''
    },
    invalidDataInfo() {
      if (this.errors.invalidCpf) {
        return i18n.t('message.pages.profile.errors.invalidCpf')
      }
      if (this.errors.invalidCnpj) {
        return i18n.t('message.pages.profile.errors.invalidCnpj')
      }
      return ''
    },
  },
  watch: {
    async locale() {
      this.isLegalPerson = true
      await this.checkPlan()
    },
    'owner.document'() {
      const document = this.unmask(this.owner.document)
      if (this.isLegalPerson && document.length >= 1) {
        this.errors.invalidCpf = !this.isValidCPF(document)
      } else if (!this.isLegalPerson && document.length >= 1) {
        this.errors.invalidCnpj = !this.isValidCNPJ(document)
      }
    },
    isLegalPerson() {
      const document = this.unmask(this.owner.document)
      if (this.isLegalPerson && document.length >= 1) {
        this.errors.invalidCnpj = false
        this.errors.invalidCpf = !this.isValidCPF(document)
      } else if (!this.isLegalPerson && document.length >= 1) {
        this.errors.invalidCpf = false
        this.errors.invalidCnpj = !this.isValidCNPJ(document)
      }
    },
    planName() {
      this.selectedPlan = this.plans.find(
        (plan) => plan.name.toLowerCase() === this.planName.toLowerCase()
      )
    },
  },
  async mounted() {
    // eslint-disable-next-line
    fbq('track', 'CompleteRegistration')
    await this.checkPlan()
    this.removeShadowWhenFocused()
  },
  methods: {
    ...mapActions('user', ['updateUser']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR', 'UPDATE_FIRST_ACCESS']),
    ...mapActions('session', ['signInUser', 'fetchSession']),
    checkIfIsValidPhoneNumber(e) {
      this.isValidPhoneNumber = e.isValid
      this.phoneInternational = e.e164
      this.handleFocus()
    },
    handleFocus() {
      const input = document.querySelector('.input-tel__input')
      if (input.style.boxShadow !== 'none') {
        input.style.boxShadow = 'none'
        input.style.caretColor = this.$vuetify.theme.dark ? '#757BA3' : '#000'
      }
    },
    removeShadowWhenFocused() {
      const customInput = document.querySelector('.country-selector__input')
      const countrySelectorToggle = document.querySelector(
        '.country-selector__toggle'
      )
      const clickFlag = document.querySelector(
        '.country-selector__country-flag'
      )
      window.addEventListener('click', () => {
        customInput.style.boxShadow = 'none'
      })
      countrySelectorToggle.addEventListener(
        'click',
        () => (customInput.style.boxShadow = 'none')
      )
      clickFlag.addEventListener(
        'click',
        () => (customInput.style.boxShadow = 'none')
      )
    },
    handleOpenMobilePlans() {
      this.mobilePlansDialog = true
    },
    async checkPlan() {
      this.productsLoading = true
      let params = {
        ...(!this.isDomainFromBrazil && { currency: 'usd' }),
        ...{ checkIp: true },
      }
      const products = await axios.get(`${API_URL}stripe/product`, {
        params,
      })
      if (
        products.headers['country-code'] === 'BR' &&
        !this.isDomainFromBrazil
      ) {
        this.$root.$emit('redirectUrlSignup')
      }

      this.plans = []
      if (products && products.data) {
        const order = { 0: 'bronze', 1: 'silver', 2: 'gold' }
        for (const [, value] of Object.entries(order)) {
          const plan = products.data.plans.find(
            ({ name }) => String(name).toLowerCase() === value
          )
          this.plans.push(plan)
        }
      }

      const cookieList = document.cookie.split('; ')
      const cookieToObjEntry = (cookie) => cookie.split('=')
      const cookieEntries = cookieList.map(cookieToObjEntry)
      const cookies = Object.fromEntries(cookieEntries)
      const couponCookie = cookies.panda_coupon

      const checkUrlParams = this.queryParamsObj()
      const planName = this.$route.query.plan || checkUrlParams.plan
      this.createAccountParamsUrl.planName = planName
        ? planName.toLowerCase()
        : 'bronze'
      const coupon =
        this.$route.query.coupon || checkUrlParams.coupon || couponCookie
      if (coupon) {
        params = { coupon, ...params }
        try {
          const coupon_info = await axios.get(`${API_URL}stripe/checkout`, {
            params,
          })
          if (coupon_info && coupon_info.data.coupon) {
            this.couponInfo = coupon_info.data.coupon
          }
        } catch (e) {
          this.errCoupon = coupon
        }
      }
      this.productsLoading = false
    },
    queryParamsObj() {
      const result = {},
        keyValuePairs = location.search.slice(1).split('&')
      keyValuePairs.forEach(function (keyValuePair) {
        keyValuePair = keyValuePair.split('=')
        result[decodeURIComponent(keyValuePair[0])] =
          decodeURIComponent(keyValuePair[1]) || ''
      })
      return result
    },
    loginPage() {
      this.$router.push({ name: 'Login' })
    },
    isValidCPF(cpf) {
      if (typeof cpf !== 'string') return false
      cpf = cpf.replace(/[^\d]+/g, '')
      if (cpf.length !== IS_CPF || !!cpf.match(/(\d)\1{10}/)) return false
      cpf = cpf.split('')
      const validator = cpf
        .filter((digit, index, array) => index >= array.length - 2 && digit)
        .map((el) => +el)
      const toValidate = (pop) =>
        cpf
          .filter((digit, index, array) => index < array.length - pop && digit)
          .map((el) => +el)
      const rest = (count, pop) =>
        ((toValidate(pop).reduce((soma, el, i) => soma + el * (count - i), 0) *
          10) %
          11) %
        10
      return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1])
    },
    isValidCNPJ(cnpj) {
      if (
        !cnpj ||
        cnpj.length != 14 ||
        cnpj == '00000000000000' ||
        cnpj == '11111111111111' ||
        cnpj == '22222222222222' ||
        cnpj == '33333333333333' ||
        cnpj == '44444444444444' ||
        cnpj == '55555555555555' ||
        cnpj == '66666666666666' ||
        cnpj == '77777777777777' ||
        cnpj == '88888888888888' ||
        cnpj == '99999999999999'
      )
        return false
      let tamanho = cnpj.length - 2
      let numeros = cnpj.substring(0, tamanho)
      let digitos = cnpj.substring(tamanho)
      let soma = 0
      let pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      let resultado = soma % IS_CPF < 2 ? 0 : 11 - (soma % IS_CPF)
      if (resultado != digitos.charAt(0)) return false
      tamanho = tamanho + 1
      numeros = cnpj.substring(0, tamanho)
      soma = 0
      pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      resultado = soma % IS_CPF < 2 ? 0 : IS_CPF - (soma % IS_CPF)
      if (resultado != digitos.charAt(1)) return false
      return true
    },
    unmask(text) {
      const defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/
      return text
        ? String(text).replace(new RegExp(defaultDelimiters, 'g'), '')
        : text
    },
    regexEmail() {
      this.trimAllFields()
      let email = this.login.user.email
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const valid = re.test(email)

      if (this.isLegalPerson && this.newUser.name.length <= 3) {
        return (this.errors.userNameInvalid = true)
      }
      if (!this.isLegalPerson && this.newUser.company.length <= 3) {
        return (this.errors.userNameInvalid = true)
      }

      if (valid && this.isValidPhoneNumber) {
        if (email === this.login.user.emailConfirm) {
          this.handleCreateAccount()
        } else {
          this.createAccountError.invalidEmail = false
          this.createAccountError.emailConfirm = true
          this.rewritingForm = false
        }
      } else if (!this.isValidPhoneNumber) {
        this.createAccountError.invalidPhoneNumber = true
      } else {
        this.createAccountError.invalidEmail = true
        this.rewritingForm = false
      }
    },
    verifyEmailConfirm() {},
    trimAllFields() {
      Object.keys(this.newUser).forEach((e) => {
        if (typeof this.newUser[e] === String)
          this.newUser[e] = this.newUser[e].trim()
      })
    },
    async handleCreateAccount() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
      const isStaging = !!window.location.host.match(/stg.dashboard|localhost/)
      let redirectURL = `https://dashboard.pandavideo.com${
        this.isDomainFromBrazil ? '.br' : ''
      }/?type=first-access&`
      if (isStaging) {
        let host = window.location.host.match(/stg.dashboard|localhost/i)
        if (host) {
          host = `https://${window.location.host}`
        } else {
          host = window.location.host
        }
        redirectURL = `${'https://dashboard.pandavideo.com'}/?type=first-access&`
      }
      const cancelURL = `https://pandavideo.com${
        this.isDomainFromBrazil ? '.br' : ''
      }/pricing/`

      // check terms acceptance

      this.errors.checkboxAcceptTerms = this.checkboxAcceptTerms ? true : false
      // check cpf or cnpj
      if (this.isDomainFromBrazil) {
        const doc = this.unmask(this.owner?.document)
        if (doc?.length === 0) {
          this.errors.cnpjCpfEmptyField = true
          return
        }
        if (!doc || (doc?.length !== IS_CNPJ && doc?.length !== IS_CPF)) {
          this.isLegalPerson
            ? (this.errors.invalidCpf = true)
            : (this.errors.invalidCnpj = true)
          return
        }
        if (doc?.length === IS_CPF) {
          const isValid = this.isValidCPF(doc)
          if (!isValid) {
            this.errors.invalidCpf = true
            return
          }
        } else if (doc?.length === IS_CNPJ || this.isLegalPerson) {
          const isValidCNPJ = this.isValidCNPJ(doc)
          if (!isValidCNPJ) {
            this.errors.invalidCnpj = true
            return
          }
        }
      }

      if (!this.errors.checkboxAcceptTerms) {
        return
      }

      const type =
        this.unmask(this.owner.document).length === IS_CPF
          ? 'br_cpf'
          : 'br_cnpj'
      this.trimAllFields()

      if (this.newUser.clientReasoning.includes('others')) {
        if (this.clientReasoningOthersText.length < 2) {
          this.errors.reasonLength = true
          return
        }
      }
      if (!this.newUser.clientReasoning.length) {
        this.errors.reasonLength = true
        return
      }
      try {
        this.signInLoading = true

        const endpoint = `${API_URL}stripe/checkout`
        const checkUrlParams = this.queryParamsObj()
        const planName = this.createAccountParamsUrl.planName

        const coupon = this.$route.query.coupon
          ? this.$route.query.coupon
          : checkUrlParams.coupon

        let objRegister = {
          email: this.login.user.email,
          name: this.isLegalPerson ? this.newUser.name : this.newUser.company,
          locale: this.isDomainFromBrazil ? 'pt' : 'en',
          plan: planName ? planName.toLowerCase() : 'bronze',
          success_url: redirectURL + `email=${this.login.user.email}`,
          cancel_url: cancelURL,
          client_phone: this.phoneInternational,
          currency: this.isDomainFromBrazil ? 'brl' : 'usd',
          ...(this.isDomainFromBrazil && {
            tax_obj: {
              type,
              value: this.unmask(this.owner.document),
            },
          }),
        }

        if (coupon && this.couponInfo) {
          objRegister['coupon'] = coupon
          objRegister['coupon_refer'] = coupon
        }

        if (this.$route.query.ref || checkUrlParams.ref) {
          const domain = this.isDomainFromBrazil ? 'br' : 'usd'
          objRegister['ref_tap_filiate'] =
            this.$route.query.ref || checkUrlParams.ref
          objRegister['ref_tap_filiate_c'] =
            this.$route.query.refc || checkUrlParams.refc
              ? this.$route.query.refc || checkUrlParams.refc
              : domain
        }
        if (
          this.$route.query.utm_source ||
          this.$route.query.utm_campaign ||
          this.$route.query.utm_content ||
          this.$route.query.gclid ||
          this.$route.query.fbclid
        ) {
          objRegister['ref_utm'] = {
            source: this.$route.query.utm_source
              ? this.$route.query.utm_source
              : '',
            campaign: this.$route.query.utm_campaign
              ? this.$route.query.utm_campaign
              : '',
            content: this.$route.query.utm_content
              ? this.$route.query.utm_content
              : '',
            gclid: this.$route.query.gclid ? this.$route.query.gclid : '',
            fbclid: this.$route.query.fbclid ? this.$route.query.fbclid : '',
          }
        }

        if (
          this.$route.query.paymentMethod === 'boleto' ||
          checkUrlParams.paymentMethod === 'boleto'
        ) {
          objRegister['enable_boleto'] = true
        }

        await axios
          .post(endpoint, objRegister)
          .finally()
          .then((response) => {
            this.firstAccess = true
            window.location.replace(response.data.url)
          })
      } catch (error) {
        this.signInLoading = false
        const anyError = JSON.parse(JSON.stringify(error))
        if (anyError.message.includes('status code 400')) {
          this.createAccountError.userAlreadyExists = true
        } else {
          this.createAccountError.internalServerError = true
        }
        this.rewritingForm = false
        this.rewritingFormCpfOrCnpj = false
      }
    },
    handleHelpDesk() {
      window.open(`${PANDA_HELP_STORAGE_LINK}`, '_blank')
    },
    handleHelpDeskTraffic() {
      window.open(`${PANDA_HELP_TRAFFIC_LINK}`, '_blank')
    },
    changePlan() {
      this.choosePlan = !this.choosePlan
    },
    onSelectPlan(plan, isMobile = false) {
      this.createAccountParamsUrl.planName = plan.name.toLowerCase()
      this.choosePlan = !this.choosePlan
      if (isMobile) this.mobilePlansDialog = false
    },
    calcBytes(planStorage) {
      let bytes = 0
      planStorage > 1024
        ? (bytes = (planStorage / 1024) * 1e12)
        : (bytes = planStorage * 1e9)
      return `${prettyBytes(bytes, { maximumFractionDigits: 0 })}`
    },
    getAmountWithCoupon(amount) {
      let ret = amount
      if (this.couponInfo['amount_off']) {
        ret = amount - this.couponInfo['amount_off']
      } else {
        ret = amount - amount * (this.couponInfo['percent_off'] / 100)
      }
      return ret >= 0 ? ret : 0
    },
    handleClearDocumentErrors() {
      this.errors.cnpjCpfEmptyField = false
      this.errors.invalidCpf = false
      this.errors.invalidCnpj = false
    },
  },
}
</script>

<style lang="scss" scoped>
.bg-dark .dialogPlansMobile {
  background-color: $color-neutral-darkest !important;
}
.theme--dark.v-card {
  background-color: $neutral-100-white-dark;
}
.theme--dark.v-application .newBackground {
  background-color: #2f3037;
}
.v-toolbar__title {
  line-height: 120%;
  font-size: 18px;
  font-weight: 500;
}
.labelPhone {
  font-size: 12px;
  line-height: 12px;
  font-weight: 500;
  color: $neutral-20-dark-light;

  &.errorMsg {
    color: $feedback-danger-light;
    font-weight: 500;
  }
}
.errorMsg {
  line-height: 18px;
  font-size: 12px;
  font-weight: 400;
  color: $feedback-danger-light;
}
.bg-dark {
  .item-plan {
    border: 2px solid $neutral-100-white-dark !important;
    background-color: $neutral-100-white-dark !important;
    &:hover {
      border: 2px solid $brand-80-light-dark !important;
    }
    &.selected {
      background-color: $brand-99-lightest-dark !important;
      border: 2px solid $brand-80-light-dark !important;
      color: $color-neutral-white;
    }
    & .circle__selected {
      background-color: $color-neutral-white;
    }
    .planTitle {
      color: $color-neutral-white;
    }
    .perkPlan {
      color: $neutral-30-base-dark;
    }
    .priceText {
      color: $color-neutral-white;
    }
  }
  .labelPhone {
    color: $neutral-40-light-dark;
    font-weight: 500;

    &.errorMsg {
      color: $feedback-danger-light;
      font-weight: 500;
    }
  }
  .termsOfUse,
  .termsFont,
  .theme--dark.v-input input,
  .signUpSubtitle,
  .signUpSubtitleCta,
  .footerLinks,
  .v-application--is-ltr .v-input--selection-controls__input {
    color: $neutral-40-light-dark !important;
  }
  .theme--dark.v-input input,
  .theme--dark.v-input textarea {
    color: $neutral-40-light-dark !important;
  }
}
.theme--dark.v-btn-toggle:not(.v-btn-toggle--group) {
  background-color: $neutral-100-white-dark;
  letter-spacing: 0.03rem;
}
.theme--dark.v-btn-toggle:not(.v-btn-toggle--group)
  .v-btn.v-btn.selectedButton {
  border-color: $color-brand !important;
  color: $brand-40-dark-dark;
  background-color: $brand-95-lighter-dark;
}
.v-btn:before {
  opacity: 0;
}
</style>
<style lang="scss">
.country-selector.has-value .country-selector__label {
  display: none !important;
}
.country-selector__country-flag {
  top: 14px !important;
}

.bg-dark .country-selector.has-hint .country-selector__input,
.bg-dark .country-selector.has-value .country-selector__input {
  background-color: $neutral-99-dark !important;
}
.iti-flag {
  border-radius: 50px !important;
}
.bg-dark .country-selector.has-hint .country-selector__input,
.bg-dark .country-selector.has-value .country-selector__input,
.bg-dark .vue-phone-number-input .input-tel__input[data-v-e59be3b4] {
  padding-top: 0 !important;
  &:hover {
    border: 1px $brand-80-light-dark solid !important;
  }
  &:focus-within {
    border: 2px $brand-60-base-dark solid !important;
  }
}
.country-selector.has-hint .country-selector__input,
.country-selector.has-value .country-selector__input,
.vue-phone-number-input .input-tel__input[data-v-e59be3b4] {
  &:hover {
    border: 1px $color-brand-light solid !important;
  }
  &:focus-within {
    border: 2px $color-brand solid !important;
  }
}
.country-selector .country-selector__list__item {
  color: #9b9b9b !important;
}
.input-tel.has-value .input-tel__input,
.input-tel.has-value .input-tel__input {
  padding-top: 0 !important;
}
.input-tel.has-value .input-tel__label {
  cursor: text;
  display: none;
}
.vue-phone-number-input .select-country-container {
  max-width: 65px !important;
  min-width: 65px !important;
  width: 65px !important;
}
.selected {
  background-color: $brand-99-lightest-light !important;
}
.item-plan {
  border: 2px solid #fff !important;

  &:hover {
    border: 2px solid $color-brand-light !important;
  }
}
.selected.item-plan {
  border: 2px solid $color-brand-light !important;
}
.trialAdvice {
  display: flex;
  align-items: end;
  font-size: 12px;
  color: $neutral-40-light-light;
}
.v-application--is-ltr .v-btn-toggle > .v-btn.v-btn:not(:first-child) {
  border-width: thin !important;
}
.circle {
  width: 24px;
  height: 23px;
  border: 2px solid $neutral-80-lighter-light;
  border-radius: 50px !important;

  &__selected {
    width: 24px;
    height: 23px;
    border: 5px solid $color-brand;
    border-radius: 50px !important;
  }
}

.compactInput.v-text-field {
  input {
    padding: 2px;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%; /* 18px */

    &::placeholder {
      color: $neutral-60-light;
    }
  }
  &--outlined fieldset {
    border-color: $neutral-95-lightest-light;
  }
}
.theme--dark.compactInput.v-text-field {
  &::placeholder {
    color: $neutral-60-dark;
  }
  &--outlined fieldset {
    border-color: $neutral-95-lightest-dark;
  }
}
.input-tel__label[data-v-e59be3b4] {
  cursor: text;
}
.country-selector__input,
.input-tel__input {
  background: $color-neutral-white;
  border: 1px solid $neutral-95-lightest-light !important;
  color: $neutral-40-light-light;
  cursor: text !important;

  &::placeholder {
    cursor: text !important;
    color: $neutral-60-light;
    font-size: 14px;
  }
  @media only screen and (max-width: 960px) {
    font-size: 16px !important;

    &::placeholder {
      font-size: 16px !important;
    }
  }
}

.input-tel.has-error:not(.is-valid) .input-tel__input[data-v-e59be3b4] {
  border-color: $feedback-danger-light-light !important;
  color: $feedback-danger-dark-light;
  cursor: text;

  &::placeholder {
    color: $neutral-60-light;
  }
}

.bg-dark
  .input-tel.has-error:not(.is-valid)
  .input-tel__input[data-v-e59be3b4] {
  border-color: $feedback-danger-light-light !important;
  color: $feedback-danger-light-light !important;

  &::placeholder {
    color: $neutral-60-dark !important;
  }
}

.bg-dark .country-selector__input[data-v-46e105de],
.bg-dark .input-tel__input[data-v-e59be3b4] {
  background: $neutral-100-white-dark !important;
  border: 1px solid $neutral-95-lightest-dark !important;
  color: $neutral-40-light-dark;

  &:hover {
    border: 1px solid $neutral-95-lightest-light !important;
  }

  &::placeholder {
    color: $neutral-40-light-dark !important;
  }
}

.input-tel.has-error:not(.is-valid) .input-tel__input[data-v-e59be3b4] {
  border: 1px solid $feedback-danger-light-light !important;
  background-color: $feedback-danger-background-light !important;
}
.bg-dark
  .input-tel.has-error:not(.is-valid)
  .input-tel__input[data-v-e59be3b4] {
  border: 1px solid $feedback-danger-light-dark !important;
  background-color: $feedback-danger-background-light-dark !important;
}

.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  height: 32px;
  letter-spacing: 0.03rem;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group)
  .v-btn.v-btn.selectedButton {
  border-color: $color-brand !important;
  color: $brand-40-dark-light;
  background-color: rgba(63, 85, 238, 0.2);
}

.theme--light.v-application .selected .text--secondary,
.theme--light.v-application .selected .text--primary {
  color: $neutral-30-base-light !important;
}

.mousePointer {
  cursor: pointer;
}

.welcomeText {
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  @media only screen and (max-width: 960px) {
    font-size: 22px;
  }
}

.subtitleText {
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.04em;
  @media only screen and (max-width: 960px) {
    font-size: 12px;
  }
}

.orText {
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.05em;
}

.textButton {
  background: none;
  border: none;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1;
}

.footerText {
  font-size: $spacing-minus-1;
  line-height: 16px;
  letter-spacing: 0.05em;
  @media only screen and (max-width: 960px) {
    font-size: 12px;
  }
}

.attributesText {
  font-weight: 500;
  font-size: $spacing-minus-1;
  line-height: 100%;
  color: var(--v-neutral-lighten1);
}

.fontWeightSubtitle {
  font-weight: 400;
}

.subtitleMarginBottom {
  margin-bottom: 6px;
}

.codeInput {
  max-width: 56px;
  height: 70px;
}

.requirementsText {
  font-weight: normal;
  font-size: $spacing-minus-1;
  line-height: 18px;
}

.codeText {
  font-weight: 600;
  font-size: 28px;
  line-height: 42px;
}

.textFieldText {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
}

.wrapText {
  word-break: keep-all;
}
.planTitle {
  font-size: 20px;
}
.perkPlan {
  font-size: 14px;
  color: $neutral-30-base-light;
}

.carroselCard {
  @media only screen and (max-width: 960px) {
    padding: 10px 0px;
  }
}

.termsFont {
  font-size: 14px;
  @media only screen and (max-width: 960px) {
    font-size: $spacing-minus-1 !important;
  }
}
.termsOfUse {
  margin: 5px 0 0 4px;
  text-decoration: none;
  color: $neutral-30-base-light !important;
  font: {
    size: 16px;
    weight: 700;
  }
}
a.footerLinks {
  color: $neutral-30-base-light;
  line-height: 150%;
  text-decoration: none;
  font: {
    size: $spacing-minus-1;
    style: normal;
    weight: 500;
  }
}
.chosePlan {
  font-weight: 500;
  font-size: $spacing-minus-1;
  line-height: 120%;
  display: flex;
}
.chosePlanColor {
  color: var(--v-neutral-base);
}
.signUpTitle {
  font-weight: 500;
  font-size: 24px;
  line-height: 28.8px;
}
.signUpTitleColor {
  color: $neutral-20-dark-light;
}
.signUpSubtitleColor {
  color: $neutral-40-light-light;
}
.accountTypeText {
  font-weight: 500;
  font-size: $spacing-minus-1;
  line-height: 100%;
  color: var(--v-neutral-lighten1);
}
.accountOptionsText {
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
}
.couponAdded {
  background-color: $feedback-success-background-light !important;
  border: 1px solid $feedback-success-light !important;
  padding: 4px 8px;
  .coupounText {
    font-weight: 500;
    font-size: 12px;
    line-height: 150%;
    color: $neutral-20-dark-light;
  }
  .couponName {
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: $neutral-40-light-light;
  }
}
.bg-dark .couponAdded {
  background-color: $feedback-success-background-dark !important;
  border: 1px solid $feedback-success-dark !important;

  .coupounText {
    color: $neutral-20-dark-dark;
  }
  .couponName {
    color: $neutral-40-light-dark;
  }
}
.invalidCoupon {
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
}
.signUpFormCard {
  margin-left: 55px;
}
.priceText {
  font-weight: 500 !important;
  font-size: 20px !important;
  color: $neutral-20-dark-light;
  @media only screen and (max-width: 960px) {
    font-size: 16px !important;
  }
}
.priceTextColor {
  color: $neutral-20-dark-light !important;
}
.buttonColors {
  background-color: var(--v-brand-base);
}

.originalValue {
  text-decoration: line-through;
  font-size: 20px;
  font-weight: 400;
  line-height: 150%;
  color: $neutral-60-light;
}
.bg-dark .originalValue {
  color: $neutral-60-dark;
}

.bg-dark,
.theme--dark {
  .accountTypeText,
  .attributesText,
  .signUpTitleColor {
    color: var(--v-neutral-lighten2);
  }

  .priceText {
    color: #8fb1e3;
  }

  .priceTextColor {
    color: #70a5f2 !important;
  }

  .signUpTitleColor {
    color: #8fb1e3;
  }
}
</style>
